export class ApiError extends Error {
    constructor(message, status) {
        super(message);
        this.name = "ApiError";
        this.status = status;
    }
}

export const apiFetch = async (path, options = {}) => {
    const { notifyOnUnauthorized = true, ...fetchOptions } = options;
    const headers = new Headers(fetchOptions.headers || {});
    headers.set("Accept", "application/json");
    if (fetchOptions.body && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }

    const response = await fetch(path, {
        ...fetchOptions,
        credentials: "include",
        headers,
    });

    if (!response.ok) {
        let payload = null;
        try {
            payload = await response.json();
        } catch (_error) {
            // A proxy or IIS error page may not be JSON.
        }
        if (response.status === 401 && notifyOnUnauthorized) {
            window.dispatchEvent(new Event("saiconnect:unauthorized"));
        }
        throw new ApiError(payload?.error || `Request failed (${response.status}).`, response.status);
    }

    if (response.status === 204) return null;
    return response.json();
};
